export default __webpack_public_path__ + "static/media/drag_icon.655f44b8.svg";